import { render, staticRenderFns } from "./IconArrowUpDown.vue?vue&type=template&id=48466370&"
import script from "./IconArrowUpDown.vue?vue&type=script&lang=js&"
export * from "./IconArrowUpDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48466370')) {
      api.createRecord('48466370', component.options)
    } else {
      api.reload('48466370', component.options)
    }
    module.hot.accept("./IconArrowUpDown.vue?vue&type=template&id=48466370&", function () {
      api.rerender('48466370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconArrowUpDown.vue"
export default component.exports